<template>
  <div class="rbd-not-found flex-center-middle">
    <a-result :title="title">
      <template #icon>
        <img
          src="../assets/images/common/not-license.png"
          alt="无资源访问权限"
        />
      </template>
      <template #subTitle>
        <p>
          <span>抱歉，您访问的页面不存在！</span>
          <span style="color: var(--theme-color)"> {{ second }} </span>
          <span>秒后返回首页</span>
        </p>
      </template>
      <template #extra>
        <a-button type="primary" @click="goHome"> 返回首页 </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
let clearSecond = null;
export default {
  name: "NotFound",
  data() {
    return {
      second: 10,
      title: "无资源访问权限",
    };
  },
  computed: {
    ...mapGetters(["gtt_userInfo"]),
  },
  mounted() {
    clearSecond = setInterval(() => {
      this.second--;
      if (this.second == 0) {
        clearInterval(clearSecond);
        this.goHome();
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(clearSecond);
  },
  methods: {
    goHome() {
      // 平台信息
      const platformInfo = JSON.parse(
        window.localStorage.getItem("PLATFORM_INFO")
      );
      if (this.gtt_userInfo.is_admin) {
        this.$router.push({ name: "cmsHome" });
      } else {
        console.log(platformInfo?.index_url);
        if (platformInfo?.index_url) {
          this.$router.push({ name: platformInfo.index_url });
        } else {
          this.$router.push({ name: "dataAnalysisHome" });
        }
      }
    },
  },
};
</script>

<style scoped>
.rbd-not-found {
  width: 100vw;
  height: 100vh;
}
</style>
